import ISpPageContext from '../../interfaces/ISpPageContext';
import Features from '@ms/odsp-utilities/lib/features/Features';

export const isOneDrive = window['_spPageContextInfo'] && (window['_spPageContextInfo'] as ISpPageContext).webTemplate === "21";

// ODC Features
export const EnableFluentStylingODC = { ODC: 'EnableFluentStylingODC' }; // For ODC

// ODB Features
export const EnableFluentStyling = { ODB: isOneDrive ? 1118 : -1118 }; // For ODB
export const OnedriveFluentCustomization = { ODB: isOneDrive ? 1155 : -1155, ODC: null, Fallback: false }; // For ODB

// SP Features
export const EnableFluentTheme = { ODB: isOneDrive ? -1248 : 1248, ODC: null, Fallback: false }; // For SP
export const FluentGrays = { ODB: isOneDrive ? -1099 : 1099, ODC: null, Fallback: false }; // For SP
export const EnableHoverCardFluent = { ODB: isOneDrive ? -1382 : 1382, ODC: false }; // For SP

export const isFluentActiveOD = Features.isFeatureEnabled(EnableFluentStyling) || Features.isFeatureEnabled(EnableFluentStylingODC);

// We want to ship hover card in consistent design for both OneDrive and SharePoint.
// This is a workaround to enable fluent design only for hover card as SharePoint fluent is not ready to ship.
// We'll remove this flight once SharePoint fluent is shipped.
export const isHoverCardFluentActive = Features.isFeatureEnabled(EnableHoverCardFluent);